<template>
  <div>
    <label
      class="label"
      for="email"
    >{{ label }}</label>
    <div
      class="input-container"
      :class="emailValidation.loading ? 'input-container--loading' : ''"
    >
      <input
        id="email"
        class="input input--email"
        :class="errorMessage ? 'input--error' : ''"
        name="email"
        required
        type="email"
        autocapitalize="off"
        autocorrect="off"
        autocomplete="email"
        :value="value"
        @input="$emit('input', $event.target.value)"
      >
    </div>
    <transition name="slide-down">
      <p
        v-if="suggestion"
        class="form__note"
      >
        Did you mean <button
          class="button-link"
          @click="useSuggestion"
        >
          {{ suggestion }}
        </button>?
      </p>
    </transition>
    <transition name="slide-down">
      <p
        v-if="errorMessage"
        class="form__error"
        v-html="errorMessage"
      />
    </transition>
  </div>
</template>
<script>
import debounce from 'lodash.debounce';

export default {
  props: {
    error: String,
    value: String,
    label: { type: String, default: 'Email Address' },
  },
  computed: {
    errorMessage() {
      if (this.error) {
        return this.error;
      }
      if (this.emailValidation.error) {
        if (this.emailValidation.error === 'EMAIL_UNAVAILABLE') {
          return 'This email address is not available. If this is you <a href="/profile/">login to continue</a>';
        }
        if (this.emailValidation.error === 'UNABLE_TO_VALIDATE') {
          return 'Unable to validate email address. Please try again or contact Customer Service for assistance.';
        }
        if (this.emailValidation.error === 'Invalid student email') {
          return 'Please enter a valid student email address.';
        }
      }
      if (this.$store.state.order.errorList) {
        const { errorList } = this.$store.state.order;
        if (errorList.includes('UserEmailAlreadyInUse')) {
          return 'This email address is not available. If this is you <a href="/profile/">login to continue</a>';
        }
        if (errorList.includes('UserEmailInvalid')) {
          return 'Please enter a valid email to finish signing up';
        }
      }
      return null;
    },
    emailValidation() {
      return this.$store.state.emailValidation;
    },
    suggestion() {
      if (this.emailValidation && this.emailValidation.suggestion) {
        return this.emailValidation.suggestion.full;
      }

      return '';
    },
  },
  methods: {
    useSuggestion() {
      this.$emit('input', this.suggestion);
      this.$store.commit('setEmailValidation', { suggestion: null });
    },
    validateEmail: debounce(function validate() {
      this.$store.dispatch('validateEmail', this.value);
    }, 300, { trailing: true }),
  },
  watch: {
    value() {
      this.$store.dispatch('cancelEmailValidation');
      this.validateEmail();
    },
  },
};
</script>
